// Compact collapsible issues panel — renders Validator output as a grouped,
// filterable list. Intended to dock at the bottom (or in a side rail) next to
// the DRD/Table/Expression views.

import './styles.css';

export class IssuesPanel {
  constructor(container, { onSelect } = {}) {
    this._container = container;
    this._onSelect = onSelect || (() => {});
    this._issues = [];
    this._filter = 'all';
    this._render();
  }

  setIssues(issues) {
    this._issues = Array.isArray(issues) ? issues : [];
    this._render();
  }

  destroy() { this._container.innerHTML = ''; }

  // ── internals ──────────────────────────────────────────────────────

  _render() {
    const errors = this._issues.filter((i) => i.severity === 'error');
    const warnings = this._issues.filter((i) => i.severity === 'warning');
    const filtered = this._filter === 'errors'
      ? errors
      : this._filter === 'warnings'
      ? warnings
      : this._issues;

    this._container.innerHTML = '';
    const root = document.createElement('div');
    root.className = 'epx-dmn-issues';

    const header = document.createElement('div');
    header.className = 'epx-dmn-issues__header';

    const title = document.createElement('div');
    title.className = 'epx-dmn-issues__title';
    title.textContent = 'Issues';

    const counts = document.createElement('div');
    counts.className = 'epx-dmn-issues__counts';
    counts.appendChild(this._pill('All', 'all', this._issues.length));
    counts.appendChild(this._pill('Errors', 'errors', errors.length, 'error'));
    counts.appendChild(this._pill('Warnings', 'warnings', warnings.length, 'warning'));

    header.appendChild(title);
    header.appendChild(counts);
    root.appendChild(header);

    if (!filtered.length) {
      const empty = document.createElement('div');
      empty.className = 'epx-dmn-issues__empty';
      empty.textContent = this._issues.length ? 'No issues in this filter.' : 'No issues found.';
      root.appendChild(empty);
    } else {
      const list = document.createElement('div');
      list.className = 'epx-dmn-issues__list';
      filtered.forEach((i) => list.appendChild(this._issueRow(i)));
      root.appendChild(list);
    }

    this._container.appendChild(root);
  }

  _pill(label, id, count, cls) {
    const btn = document.createElement('button');
    btn.className = `epx-dmn-issues__pill${this._filter === id ? ' epx-dmn-issues__pill--active' : ''}`;
    if (cls) btn.classList.add(`epx-dmn-issues__pill--${cls}`);
    const txt = document.createElement('span');
    txt.textContent = label;
    const n = document.createElement('span');
    n.className = 'epx-dmn-issues__pill-count';
    n.textContent = count;
    btn.appendChild(txt);
    btn.appendChild(n);
    btn.addEventListener('click', () => { this._filter = id; this._render(); });
    return btn;
  }

  _issueRow(issue) {
    const row = document.createElement('div');
    row.className = `epx-dmn-issues__row epx-dmn-issues__row--${issue.severity}`;
    row.addEventListener('click', () => this._onSelect(issue));

    const sev = document.createElement('span');
    sev.className = `epx-dmn-issues__sev epx-dmn-issues__sev--${issue.severity}`;
    sev.textContent = issue.severity === 'error' ? '!' : 'i';

    const msg = document.createElement('span');
    msg.className = 'epx-dmn-issues__msg';
    msg.textContent = issue.message;

    const meta = document.createElement('span');
    meta.className = 'epx-dmn-issues__meta';
    meta.textContent = `${issue.ruleId}${issue.elementId ? ` · ${issue.elementId}` : ''}`;

    row.appendChild(sev);
    row.appendChild(msg);
    row.appendChild(meta);
    return row;
  }
}
